module.exports = __webpack_public_path__ + "static/img/peixun2.d5d2a3c3.png";